import { STATUS_META, TONE_CLASS, statusLabel } from "@/lib/status";
import { cn } from "@/lib/utils";

export function StatusBadge({ status, mode, kind = "laundry", className }) {
  const meta = STATUS_META[status];
  if (!meta) return null;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={cn("inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold", TONE_CLASS[meta.tone], className)}
    >
      {statusLabel(status, mode, kind)}
    </span>
  );
}

export function Chip({ active, onClick, children, testId }) {
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={onClick}
      className={cn(
        "whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors border",
        active
          ? "bg-primary text-primary-foreground border-primary"
          : "bg-card text-foreground border-border hover:border-primary/40",
      )}
    >
      {children}
    </button>
  );
}
